export default __webpack_public_path__ + "static/Supersonic-min-ad2b9b55f90a19456c4d5ae67154406c.png";